import React from "react";
import Slider from "react-slick";
import { FaBed, FaArrowsAlt, FaBath, FaBuilding } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const card = [
    {
    image: "marquisvista.jpg",
    heading: "Marquis Vista",
    para: "United Arab Emirates",
    url: "Marquis Vista.pdf",
  },
  {
    image: "Masaar.png",
    heading: "Masaar 2 Coral",
    para: "United Arab Emirates",
    url: "Masaar 2 Coral.pdf",
  },
  {
    image: "damac.png",
    heading: "DAMAC ISLANDS",
    para: "United Arab Emirates",
    url: "56.pdf",
  },
  {
    image: "cove.png",
    heading: "Cove Boulevard",
    para: "United Arab Emirates",
    url: "57.pdf",
  },
  {
    image: "Pelagos.png",
    heading: "Pelagos by IGO",
    para: "United Arab Emirates",
    price: "₹20500",
    url: "Pelagos By IGO.pdf",
  },
  {
    image: "samanabarari.png",
    heading: "Samana Barari Lagoons",
    para: "United Arab Emirates",
    url: "Samana Barari Lagoons.pdf",
  },
  {
    image: "sidr.png",
    heading: "Sidr Residences",
    para: "United Arab Emirates",
    url: "Sidr Residences.pdf",
  },
  {
    image: "skyresidence.png",
    heading: "Sky Residences",
    para: "United Arab Emirates",
    price: "₹40500",
    url: "Sky Residences.pdf",
  },
  {
    image: "south.png ",
    heading: "South Garden",
    para: "United Arab Emirates",
    price: "₹50500",
    url: "South Garden.pdf",
  },
  {
    image: "thepier.png",
    heading: "The Pier residence",
    para: "United Arab Emirates",
    price: "₹40500",
    url: "The Pier residence.pdf",
  },
  {
    image: "vellore.png",
    heading: "Velora and Venera at The Valley",
    para: "United Arab Emirates",
    url: "Velora and Venera at The Valley.pdf",
  },
   {
    image: "Beachwalk.png",
    heading: "Beach Walk Residence 4",
    para: "United Arab Emirates",
    price: "15-20 AED/sqft",
    url: "Beach Walk 4.pdf",
    status: "Recently Launched",
  },
];

const Project = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="lg:px-32 md:px-5">
      <Slider {...settings}>
        {card.map((item, index) => (
          <div key={index} className="px-2">
            <div className="w-full overflow-hidden shadow-lg bg-white">
              {/* Image */}
              <div className="relative group hover:cursor-pointer overflow-hidden">
                <img
                  src={item.image}
                  alt={item.heading}
                  className="w-full h-[200px] object-cover hover:scale-125 transition duration-1000"
                />
                <div className="absolute top-4 right-4 hover:cursor-pointer z-10">
                  <button className="bg-[#FA6742] text-white px-2 text-sm tracking-tight">
                    For Sale
                  </button>
                </div>
              </div>

              {/* Content */}
              <div className="p-4">
                <h2 className="text-xl font-bold text-gray-800">{item.heading}</h2>
                <div className="flex gap-2 p-2 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#0085c4"
                  >
                    <path d="M480-477.61q34.2 0 58.29-24.1 24.1-24.09 24.1-58.29t-24.1-58.29q-24.09-24.1-58.29-24.1t-58.29 24.1q-24.1 24.09-24.1 58.29t24.1 58.29q24.09 24.1 58.29 24.1Zm0 405.74Q315.17-211.26 233.52-329.36q-81.65-118.1-81.65-223.6 0-153.28 98.95-244.22 98.95-90.95 229.18-90.95 130.23 0 229.18 90.95 98.95 90.94 98.95 244.22 0 105.5-81.65 223.6T480-71.87Z" />
                  </svg>
                  <p className="text-sm text-gray-400">{item.para}</p>
                </div>
              </div>

              {/* Download Button */}
              <div className="p-4 flex justify-around items-center border-t">
                <a href={item.url} download>
                  <button className="px-4 py-2 rounded bg-[#9A7B4F] text-white text-sm sm:text-base hover:bg-[#503617] hover:scale-105 hover:shadow-lg transition-all duration-300">
                    Download
                  </button>
                </a>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Project;
